var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _g, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _g2, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _path221, _path222, _path223, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyCapInjectionUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1391,
    height: 615,
    viewBox: "0 0 1391 615",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1391,
    height: 614.607,
    rx: 7.78788,
    fill: "#232A58"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M710.537 309.985H686.419L681.443 314.961H660.77V321.852H499.984V314.961H493.859V310.368H487.734V315.727H428.014V310.368H424.951V315.727H365.996V309.602H358.34V314.961H300.15V311.133H286.369V304.242H282.541V314.196V318.024H274.884V314.196H270.29V318.024H261.868V305.008H254.212V298.883H228.18L224.734 295.437V291.992L221.097 288.355V278.976L225.018 275.056V268.257H251.915V263.663H256.509V246.819H259.571V239.928H262.634V233.803H289.431V236.1H303.979V233.803H323.12V236.1H325.417V243.756H323.12V246.053H288.666V248.35H279.478V256.772V264.429H286.369V258.288H300.15V252.944H349.152V251.413H614.831V256.772H619.425L624.785 251.413H682.974V256.007H708.769H711.303V263.663H744.991V261.366H749.585V258.304H753.413V256.007H760.304V254.475H766.429V252.944H771.023V251.413H777.148V249.881H784.039V248.35H789.399V246.819H793.993V245.288H798.587V243.756H805.477V242.225H810.837V240.694H817.728V239.162H835.338H841.463L845.291 235.334H940.997L947.888 228.443H986.17V247.585H989.998V245.288H1084.17V231.506H1093.36V229.209H1143.89L1147.72 233.037V340.993L1143.89 344.822H1127.81V337.165H1122.46V334.103H1102.55V323.384H1087.24L1083.79 319.938H989.998L987.51 317.45H970.857H957.076",
    fill: "#9DABAB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1119.39 408.361H310.104V552.303H1119.39V408.361Z",
    fill: "url(#paint0_linear_2714_20238)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1119.39 402.248H226.649V408.373H1119.39V402.248Z",
    fill: "#E4E2D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1119.39 389.221H226.649V402.237H1119.39V389.221Z",
    fill: "#E4E2D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M245.53 368.561H230.477V389.233H1169.9V368.561H261.83",
    fill: "#E4E2D7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M245.223 368.561H226.671V361.67H588.034",
    fill: "#838697"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M245.223 368.561H226.671V361.67H588.034",
    stroke: "#838697",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M611.6 361.67H1169.9V368.561H261.707",
    fill: "url(#paint1_linear_2714_20238)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1069.66 346.357H616.363V361.67H1153.85V346.357H1096.34",
    fill: "#E4E2D7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1119.41 434.712H1150.33L1165.95 389.264H1119.41V434.712Z",
    fill: "#838697"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1140.07 420.624C1145.99 420.624 1150.78 415.825 1150.78 409.905C1150.78 403.985 1145.99 399.186 1140.07 399.186C1134.15 399.186 1129.35 403.985 1129.35 409.905C1129.35 415.825 1134.15 420.624 1140.07 420.624Z",
    fill: "#DFDDCD"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.638 386.735C259.663 386.735 264.548 381.85 264.548 375.825C264.548 369.799 259.663 364.914 253.638 364.914C247.612 364.914 242.727 369.799 242.727 375.825C242.727 381.85 247.612 386.735 253.638 386.735Z",
    fill: "url(#paint2_linear_2714_20238)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.34 350.059H1099.49V361.023H789.399V350.059H1069.66",
    fill: "#9DABAB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1069.4 355.794H754.179V344.049H771.728",
    fill: "#E4E2D7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.34 344.049H1099.49V355.794H1096.22",
    fill: "#9DABAB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1096.42 337.16H1069.63V360.895H1096.42V337.16Z",
    fill: "#9DABAB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1061.55 357.842H1055.5V360.904H1061.55V357.842Z",
    fill: "#212120"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M850.651 364.732H829.978V367.795H850.651V364.732Z",
    fill: "#845914"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M850.651 367.795H829.979V373.92H850.651V367.795Z",
    fill: "#845914"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M832.275 376.6C832.91 376.6 833.424 376.085 833.424 375.451C833.424 374.817 832.91 374.303 832.275 374.303C831.641 374.303 831.127 374.817 831.127 375.451C831.127 376.085 831.641 376.6 832.275 376.6Z",
    fill: "#845914"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M839.932 376.6C840.566 376.6 841.081 376.085 841.081 375.451C841.081 374.817 840.566 374.303 839.932 374.303C839.298 374.303 838.784 374.817 838.784 375.451C838.784 376.085 839.298 376.6 839.932 376.6Z",
    fill: "#845914"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M847.588 376.6C848.223 376.6 848.737 376.085 848.737 375.451C848.737 374.817 848.223 374.303 847.588 374.303C846.954 374.303 846.44 374.817 846.44 375.451C846.44 376.085 846.954 376.6 847.588 376.6Z",
    fill: "#845914"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M886.637 364.732H865.964V367.795H886.637V364.732Z",
    fill: "#845914"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M886.636 367.795H865.963V373.92H886.636V367.795Z",
    fill: "#845914"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M868.261 376.6C868.895 376.6 869.409 376.085 869.409 375.451C869.409 374.817 868.895 374.303 868.261 374.303C867.626 374.303 867.112 374.817 867.112 375.451C867.112 376.085 867.626 376.6 868.261 376.6Z",
    fill: "#845914"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M875.917 376.6C876.551 376.6 877.065 376.085 877.065 375.451C877.065 374.817 876.551 374.303 875.917 374.303C875.283 374.303 874.769 374.817 874.769 375.451C874.769 376.085 875.283 376.6 875.917 376.6Z",
    fill: "#845914"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M883.574 376.6C884.208 376.6 884.722 376.085 884.722 375.451C884.722 374.817 884.208 374.303 883.574 374.303C882.939 374.303 882.425 374.817 882.425 375.451C882.425 376.085 882.939 376.6 883.574 376.6Z",
    fill: "#845914"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M963.966 364.732H943.294V367.795H963.966V364.732Z",
    fill: "#845914"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M963.966 367.795H943.294V373.92H963.966V367.795Z",
    fill: "#845914"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M945.59 376.6C946.224 376.6 946.738 376.085 946.738 375.451C946.738 374.817 946.224 374.303 945.59 374.303C944.956 374.303 944.441 374.817 944.441 375.451C944.441 376.085 944.956 376.6 945.59 376.6Z",
    fill: "#845914"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M953.246 376.6C953.881 376.6 954.395 376.085 954.395 375.451C954.395 374.817 953.881 374.303 953.246 374.303C952.612 374.303 952.098 374.817 952.098 375.451C952.098 376.085 952.612 376.6 953.246 376.6Z",
    fill: "#845914"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M960.903 376.6C961.537 376.6 962.051 376.085 962.051 375.451C962.051 374.817 961.537 374.303 960.903 374.303C960.269 374.303 959.754 374.817 959.754 375.451C959.754 376.085 960.269 376.6 960.903 376.6Z",
    fill: "#845914"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M999.187 364.732H978.514V367.795H999.187V364.732Z",
    fill: "#845914"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M999.187 367.795H978.514V373.92H999.187V367.795Z",
    fill: "#845914"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M980.812 376.6C981.446 376.6 981.96 376.085 981.96 375.451C981.96 374.817 981.446 374.303 980.812 374.303C980.177 374.303 979.663 374.817 979.663 375.451C979.663 376.085 980.177 376.6 980.812 376.6Z",
    fill: "#845914"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M988.468 376.6C989.102 376.6 989.617 376.085 989.617 375.451C989.617 374.817 989.102 374.303 988.468 374.303C987.834 374.303 987.32 374.817 987.32 375.451C987.32 376.085 987.834 376.6 988.468 376.6Z",
    fill: "#845914"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M996.125 376.6C996.759 376.6 997.273 376.085 997.273 375.451C997.273 374.817 996.759 374.303 996.125 374.303C995.49 374.303 994.976 374.817 994.976 375.451C994.976 376.085 995.49 376.6 996.125 376.6Z",
    fill: "#845914"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1113.65 344.816H1099.87V348.645H1113.65V344.816Z",
    fill: "#9DABAB"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.85 348.645H1099.87V352.473H1104.85V348.645Z",
    fill: "#9DABAB"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1117.86 346.357V350.186H1112.5V353.248H1108.67L1101.09 360.828H1153.71V346.357H1117.86Z",
    fill: "#9DABAB"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M749.585 261.36V265.188H765.664V256.766H801.649V260.594H820.79V275.141",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M834.572 277.449H823.087V288.934H834.572V277.449Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M744.991 304.246H710.537V315.731H744.991V304.246Z",
    fill: "#E4E2D7"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M800.884 304.246H748.82V334.106H800.884V304.246Z",
    fill: "#E4E2D7"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M753.268 291.55V295.049H823.088V291.221",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M821.357 295.16V308.835H801.136",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M720.315 309.98C721.224 309.98 721.961 309.243 721.961 308.334C721.961 307.424 721.224 306.688 720.315 306.688C719.405 306.688 718.668 307.424 718.668 308.334C718.668 309.243 719.405 309.98 720.315 309.98Z",
    fill: "#212120"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M733.331 309.98C734.24 309.98 734.977 309.243 734.977 308.334C734.977 307.424 734.24 306.688 733.331 306.688C732.422 306.688 731.685 307.424 731.685 308.334C731.685 309.243 732.422 309.98 733.331 309.98Z",
    fill: "#212120"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M744.991 304.246H750.795",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M841.938 332.78H923.862V324.357H841.938",
    fill: "#9DABAB"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M744.991 315.73H749.248",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M807.774 334.105H764.898V337.934H807.774V334.105Z",
    fill: "#9DABAB"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M781.452 342.133C781.875 342.133 782.218 341.79 782.218 341.367C782.218 340.944 781.875 340.602 781.452 340.602C781.029 340.602 780.686 340.944 780.686 341.367C780.686 341.79 781.029 342.133 781.452 342.133Z",
    fill: "#9DABAB"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M781.452 345.961C781.875 345.961 782.218 345.618 782.218 345.195C782.218 344.772 781.875 344.43 781.452 344.43C781.029 344.43 780.686 344.772 780.686 345.195C780.686 345.618 781.029 345.961 781.452 345.961Z",
    fill: "#9DABAB"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M779.155 344.047C779.578 344.047 779.921 343.704 779.921 343.281C779.921 342.858 779.578 342.516 779.155 342.516C778.732 342.516 778.389 342.858 778.389 343.281C778.389 343.704 778.732 344.047 779.155 344.047Z",
    fill: "#9DABAB"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M797.531 345.961C797.954 345.961 798.296 345.618 798.296 345.195C798.296 344.772 797.954 344.43 797.531 344.43C797.108 344.43 796.765 344.772 796.765 345.195C796.765 345.618 797.108 345.961 797.531 345.961Z",
    fill: "#9DABAB"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M797.531 342.133C797.954 342.133 798.296 341.79 798.296 341.367C798.296 340.944 797.954 340.602 797.531 340.602C797.108 340.602 796.765 340.944 796.765 341.367C796.765 341.79 797.108 342.133 797.531 342.133Z",
    fill: "#9DABAB"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M799.828 344.047C800.251 344.047 800.593 343.704 800.593 343.281C800.593 342.858 800.251 342.516 799.828 342.516C799.405 342.516 799.062 342.858 799.062 343.281C799.062 343.704 799.405 344.047 799.828 344.047Z",
    fill: "#9DABAB"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M776.383 338.688H771.79V344.047H776.383V338.688Z",
    fill: "#9DABAB"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M807.009 338.688H802.415V346.344H807.009V338.688Z",
    fill: "#9DABAB"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M776.452 344.049V347.111H807.392",
    fill: "#9DABAB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M807.774 334.105H820.79V344.825H830.744V334.871",
    fill: "#9DABAB"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M830.744 334.872H823.087V304.246H829.817",
    fill: "#9DABAB"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M840.697 305H834.572V346.345H840.697V305Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M807.507 344.089H816.197V340.988H820.89",
    fill: "#9DABAB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M834.381 322.522C831.77 321.205 829.978 318.495 829.978 315.371V289.002",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M829.978 277.341V258.667C829.978 254.241 833.561 250.658 837.987 250.658H913.082C917.507 250.658 921.09 254.241 921.09 258.667V315.386C921.09 319.811 917.507 323.395 913.082 323.395H840.613",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M834.381 322.524C831.77 321.207 829.978 318.496 829.978 315.373V289.188",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.89 269.793H1085.71V295.059H1094.89V269.793Z",
    fill: "url(#paint3_linear_2714_20238)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.14 275.141H1097.95V291.985H1107.14V275.141Z",
    fill: "url(#paint4_linear_2714_20238)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.72 275.141H1136.24V287.391H1147.72V275.141Z",
    fill: "url(#paint5_linear_2714_20238)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M913.434 265.189V269.806",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M913.434 298.109V302.726",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M928.747 310.361H925.684V308.064C925.684 307.222 926.373 306.533 927.216 306.533C928.058 306.533 928.747 307.222 928.747 308.064V310.361Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M953.248 316.484H950.185V314.953C950.185 314.111 950.874 313.422 951.716 313.422C952.559 313.422 953.248 314.111 953.248 314.953V316.484Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M933.119 305.719V315.726H936.404V313.429H938.7V332.57H942.529V330.273H978.514V335.633H985.405V317.893H977.856V326.445H942.529V314.194H944.826V318.023H957.076V314.194H961.67V305.941",
    fill: "#9DABAB"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M941.48 305.867V311.135H945.002V305.684",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M935.354 305.857V311.125H938.111V305.857",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.044 256.766H921.091V262.891H931.044V256.766Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.45 253.705H923.388V256.768H926.45V253.705Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.186 249.877H953.248V251.408C953.248 252.25 952.559 252.94 951.717 252.94C950.875 252.94 950.186 252.25 950.186 251.408V249.877Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.623 249.877H974.686V251.408C974.686 252.25 973.997 252.94 973.155 252.94C972.312 252.94 971.623 252.25 971.623 251.408V249.877Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.28 249.877H982.342V251.408C982.342 252.25 981.653 252.94 980.811 252.94C979.969 252.94 979.28 252.25 979.28 251.408V249.877Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.874 259.061H986.937V260.592C986.937 261.434 986.248 262.123 985.405 262.123C984.563 262.123 983.874 261.434 983.874 260.592V259.061Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.531 259.061H994.593V260.592C994.593 261.434 993.904 262.123 993.062 262.123C992.22 262.123 991.531 261.434 991.531 260.592V259.061Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.044 262.893H944.06M944.06 262.893V255.719C944.06 252.495 946.671 249.877 949.902 249.877H986.171V259.065H972.389V264.424H944.06V262.893Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.171 259.061H999.953",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M986.171 249.875H998.421L1001.1 247.195H1084.17V259.063H1075.75",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.44 256.09H963.684V261.357H966.44V256.09Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M999.951 308.828H972.388V303.852H968.177L966.263 305.766H922.966L924.382 314.188L924.045 315.336L920.125 316.485L919.084 320.665L910.623 321.308L924.152 334.86H934.871V343.282H847.588V340.22H843.07V334.409",
    fill: "#9DABAB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M978.514 332.564H934.872V346.346H978.514V332.564Z",
    fill: "#9DABAB"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M1097.95 267.484H1094.89V298.876H1097.95V267.484Z",
    fill: "url(#paint6_linear_2714_20238)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.78 319.559H1091.83V322.621H1101.78V319.559Z",
    fill: "url(#paint7_linear_2714_20238)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M1111.74 232.264H1094.89V262.89H1111.74V232.264Z",
    fill: "url(#paint8_linear_2714_20238)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.85 262.889H1101.78V269.014H1104.85V262.889Z",
    fill: "url(#paint9_linear_2714_20238)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M1104.08 269.025H1102.55V275.151H1104.08V269.025Z",
    fill: "url(#paint10_linear_2714_20238)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M1105.61 269.025H1104.08V275.151H1105.61V269.025Z",
    fill: "url(#paint11_linear_2714_20238)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M1107.14 269.025H1105.61V275.151H1107.14V269.025Z",
    fill: "url(#paint12_linear_2714_20238)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M1102.55 269.025H1101.02V275.151H1102.55V269.025Z",
    fill: "url(#paint13_linear_2714_20238)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M1101.02 269.025H1099.49V275.151H1101.02V269.025Z",
    fill: "url(#paint14_linear_2714_20238)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M1099.49 269.025H1097.95V275.151H1099.49V269.025Z",
    fill: "url(#paint15_linear_2714_20238)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.51 339.453H1071.54V344.047H1094.51V339.453Z",
    fill: "#9DABAB"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.51 354.768H1071.54V359.361H1094.51V354.768Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.51 345.59H1071.54V352.481H1094.51V345.59Z",
    fill: "#9DABAB"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M881.276 315.336H862.901V322.992H881.276V315.336Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M878.979 312.275H869.026V314.955H878.979V312.275Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M867.495 312.275H865.198V314.955H867.495V312.275Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M798.587 251.404H791.696V256.764H798.587V251.404Z",
    fill: "#E4E2D7"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M784.828 252.564H779.415V256.776H784.828V252.564Z",
    fill: "#E4E2D7"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M841.34 250.702V239.539",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M710.538 255.999V242.983H705.178V221.545H749.586V246.046H744.992V262.124",
    fill: "#9DABAB"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M337.667 275.906H330.011V291.219H337.667V275.906Z",
    fill: "url(#paint16_linear_2714_20238)",
    stroke: "url(#paint17_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M330.011 278.969H326.182V288.157H330.011V278.969Z",
    fill: "url(#paint18_linear_2714_20238)",
    stroke: "url(#paint19_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M326.182 276.682H322.354V289.698H326.182V276.682Z",
    fill: "url(#paint20_linear_2714_20238)",
    stroke: "url(#paint21_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M318.526 276.682H314.698V289.698H318.526V276.682Z",
    fill: "url(#paint22_linear_2714_20238)",
    stroke: "url(#paint23_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M322.354 273.621H318.526V292.762H322.354V273.621Z",
    fill: "url(#paint24_linear_2714_20238)",
    stroke: "url(#paint25_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.26 260.594H288.666V268.25H293.26V260.594Z",
    fill: "#E4E2D7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.008 262.889H320.058V265.951H293.199",
    fill: "#E4E2D7"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.932 275.314V269.021H311.444V266.211H302.447V271.318H311.635V275.912",
    fill: "#E4E2D7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M320.057 261.742H319.292V267.102H320.057V261.742Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.26 300.418H288.666V308.074H293.26V300.418Z",
    fill: "#E4E2D7"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M293.008 302.705H320.058V305.768H293.199",
    fill: "#E4E2D7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M313.932 289.01V299.897H311.444V302.707H302.447V297.6H311.635V291.475",
    fill: "#E4E2D7"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.057 301.564H319.292V306.924H320.057V301.564Z",
    fill: "#E4E2D7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M306.276 239.166H287.135V242.229H306.276V239.166Z",
    fill: "#E4E2D7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M320.823 237.625H306.276V243.75H320.823V237.625Z",
    fill: "#E4E2D7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M287.135 237.625H272.587V243.75H287.135V237.625Z",
    fill: "#E4E2D7"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M264.165 302.705V311.127H265.696V314.955H267.993V311.893H276.416V314.955H280.244V302.705H275.65V305.002H271.822V302.705H264.165Z",
    fill: "#E4E2D7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M256.126 296.504V302.713H264.242",
    fill: "#E4E2D7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M277.181 298.109H272.587V300.406H277.089",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.978 296.971H230.094L227.414 294.291V288.166H254.978V296.971Z",
    fill: "#E4E2D7"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.681 291.994H231.243V295.057H252.681V291.994Z",
    fill: "#E4E2D7"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.681 289.686H231.243V290.451H252.681V289.686Z",
    fill: "#E4E2D7"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M254.978 269.793H230.094L227.414 272.473V278.598H254.978V269.793Z",
    fill: "#E4E2D7"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.681 271.707H231.243V274.77H252.681V271.707Z",
    fill: "#E4E2D7"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M252.681 276.287H231.243V277.053H252.681V276.287Z",
    fill: "#E4E2D7"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M253.446 269.018V265.19H258.04V249.111H263.4C263.4 250.382 264.426 251.408 265.697 251.408H266.608C267.794 251.408 268.759 250.444 268.759 249.257V246.049H277.181V263.659H274.884V265.956H271.056V269.018H253.446Z",
    fill: "#E4E2D7"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M265.696 249.885C266.542 249.885 267.228 249.199 267.228 248.354C267.228 247.508 266.542 246.822 265.696 246.822C264.851 246.822 264.165 247.508 264.165 248.354C264.165 249.199 264.851 249.885 265.696 249.885Z",
    fill: "#E4E2D7"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M271.822 242.983H267.228V245.28H265.697C264.426 245.28 263.4 246.306 263.4 247.577H261.103V241.451H264.165V236.092H271.822V242.983Z",
    fill: "#E4E2D7"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M743.46 276.75V267.21V256.047V230.734H710.537V257.31V267.21V275.632",
    fill: "#9DABAB"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M739.632 261.744C740.266 261.744 740.78 261.23 740.78 260.596C740.78 259.961 740.266 259.447 739.632 259.447C738.997 259.447 738.483 259.961 738.483 260.596C738.483 261.23 738.997 261.744 739.632 261.744Z",
    fill: "#212120"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M714.366 261.744C715 261.744 715.514 261.23 715.514 260.596C715.514 259.961 715 259.447 714.366 259.447C713.731 259.447 713.217 259.961 713.217 260.596C713.217 261.23 713.731 261.744 714.366 261.744Z",
    fill: "#212120"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M704.412 200.109H708.577L705.178 221.547V217.336H700.201V208.149H704.412V200.109Z",
    fill: "#98A8A7"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M708.669 199.533L709.006 200.107H708.577L708.669 199.533Z",
    fill: "#98A8A7"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M745.267 198.344L745.474 200.112H744.226L745.267 198.344Z",
    fill: "#98A8A7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M748.82 208.149H753.031V217.336H748.054V221.547L745.474 200.109H748.82V208.149Z",
    fill: "#98A8A7"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M746.523 202.404H705.943V206.233H746.523V202.404Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M751.116 210.061H702.115V213.889H751.116V210.061Z",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M704.412 200.109H760.304V204.703H767.961V208.531H802.415V221.547H705.178L700.201 217.336V212.995V210.063V208.149L704.412 200.109Z",
    fill: "url(#paint26_linear_2714_20238)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M748.552 205.418H756.476V208.534H759.539V213.128V217.722H753.031L748.552 205.418Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M798.587 212.369H759.539V217.729H798.587V212.369Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M581.143 347.877H274.885V361.659H581.143V347.877Z",
    fill: "#E4E2D7"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M588.111 361.671H581.143V334.873H616.363V361.671H611.922",
    fill: "#E4E2D7"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M611.769 354.768H588.034V368.549H611.769V354.768Z",
    fill: "url(#paint27_linear_2714_20238)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M715.131 213.889H710.537V221.545H715.131V213.889Z",
    fill: "#9DABAB"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M744.226 213.889H739.632V221.545H744.226V213.889Z",
    fill: "#9DABAB"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M931.044 296.201H921.09V302.326H931.044V296.201Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M926.45 302.324H923.387V305.387H926.45V302.324Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M950.185 309.215V307.684C950.185 306.841 950.874 306.152 951.716 306.152C952.558 306.152 953.247 306.841 953.247 307.684V309.215H950.185Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.623 309.215V307.684C971.623 306.841 972.312 306.152 973.154 306.152C973.996 306.152 974.685 306.841 974.685 307.684V309.215H971.623Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.279 309.215V307.684C979.279 306.841 979.968 306.152 980.811 306.152C981.653 306.152 982.342 306.841 982.342 307.684V309.215H979.279Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.874 300.025V298.494C983.874 297.652 984.563 296.963 985.405 296.963C986.247 296.963 986.936 297.652 986.936 298.494V300.025H983.874Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M991.53 300.025V298.494C991.53 297.652 992.219 296.963 993.061 296.963C993.904 296.963 994.593 297.652 994.593 298.494V300.025H991.53Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.059 296.199V294.668H972.388V300.027H986.17V309.215H949.901C946.67 309.215 944.059 306.597 944.059 303.373V296.199ZM944.059 296.199H931.043",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.952 300.029H986.17",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.75 300.029H1084.17V311.897H1001.1L998.421 309.217H986.17",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.439 297.729H963.683V302.996H966.439V297.729Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  }))), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M1077.43 298.47V301.946H1091.06L1093.36 304.243V319.556H1100.25V306.54H1106.38V300.415H1108.67V292.207",
    fill: "url(#paint28_linear_2714_20238)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.79 266.416H1090.3V263.66H1094.89V258.561",
    fill: "url(#paint29_linear_2714_20238)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M1090.3 285.86C1092.2 285.86 1093.74 284.317 1093.74 282.414C1093.74 280.511 1092.2 278.969 1090.3 278.969C1088.4 278.969 1086.85 280.511 1086.85 282.414C1086.85 284.317 1088.4 285.86 1090.3 285.86Z",
    fill: "url(#paint30_linear_2714_20238)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M314.698 275.141H313.167V291.985H314.698V275.141Z",
    fill: "#56A3D2"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M313.358 276.098H306.498C305.939 276.098 305.395 276.274 304.943 276.595L297.991 281.564C296.491 282.636 296.498 284.864 298.007 285.929L304.568 290.545C305.02 290.859 305.556 291.035 306.107 291.035H313.174",
    fill: "#56A3D2"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M298.16 286.291H230.423V280.84H298.635",
    fill: "#56A3D2"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M230.814 286.291H226.518C225.523 286.291 224.719 285.487 224.719 284.492V282.639C224.719 281.644 225.523 280.84 226.518 280.84H230.852",
    fill: "#56A3D2"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M337.667 275.535H355.951H823.087V291.614H337.667V275.535Z",
    fill: "url(#paint31_linear_2714_20238)",
    stroke: "url(#paint32_linear_2714_20238)",
    strokeMiterlimit: 10
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M350.446 291.995L347.199 275.725",
    stroke: "url(#paint33_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M362.329 291.995L359.075 275.725",
    stroke: "url(#paint34_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M374.204 291.995L370.957 275.725",
    stroke: "url(#paint35_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M386.087 291.995L382.833 275.725",
    stroke: "url(#paint36_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M397.962 291.995L394.716 275.725",
    stroke: "url(#paint37_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M409.837 291.995L406.591 275.725",
    stroke: "url(#paint38_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M421.72 291.995L418.466 275.725",
    stroke: "url(#paint39_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M433.595 291.995L430.349 275.725",
    stroke: "url(#paint40_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M445.478 291.995L442.224 275.725",
    stroke: "url(#paint41_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M457.353 291.995L454.107 275.725",
    stroke: "url(#paint42_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M469.235 291.995L465.981 275.725",
    stroke: "url(#paint43_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M481.111 291.995L477.865 275.725",
    stroke: "url(#paint44_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M492.986 291.995L489.74 275.725",
    stroke: "url(#paint45_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M504.869 291.995L501.622 275.725",
    stroke: "url(#paint46_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M516.744 291.995L513.498 275.725",
    stroke: "url(#paint47_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M528.627 291.995L525.373 275.725",
    stroke: "url(#paint48_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M540.502 291.995L537.256 275.725",
    stroke: "url(#paint49_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M552.385 291.995L549.131 275.725",
    stroke: "url(#paint50_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M564.26 291.995L561.014 275.725",
    stroke: "url(#paint51_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M576.136 291.995L572.889 275.725",
    stroke: "url(#paint52_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M588.018 291.995L584.772 275.725",
    stroke: "url(#paint53_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M599.894 291.995L596.648 275.725",
    stroke: "url(#paint54_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M611.776 291.995L608.522 275.725",
    stroke: "url(#paint55_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M623.651 291.995L620.405 275.725",
    stroke: "url(#paint56_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M635.535 291.995L632.281 275.725",
    stroke: "url(#paint57_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M647.409 291.995L644.163 275.725",
    stroke: "url(#paint58_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M659.284 291.995L656.038 275.725",
    stroke: "url(#paint59_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M671.168 291.995L667.922 275.725",
    stroke: "url(#paint60_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M683.043 291.995L679.796 275.725",
    stroke: "url(#paint61_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M694.926 291.995L691.672 275.725",
    stroke: "url(#paint62_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M706.801 291.995L703.554 275.725",
    stroke: "url(#paint63_linear_2714_20238)",
    strokeWidth: 5,
    strokeMiterlimit: 10
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M259.111 280.544V277.061H256.125V270.17H268.376V277.826H270.673V280.039",
    fill: "url(#paint64_linear_2714_20238)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M259.111 286.895V289.613H256.125V296.504H268.376V288.847H270.673V286.635",
    fill: "url(#paint65_linear_2714_20238)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M277.181 280.51V277.447H281.009V275.15H285.603V277.447H289.431V280.51",
    fill: "url(#paint66_linear_2714_20238)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M289.431 286.25V289.313H285.603V291.61H281.009V289.313H277.181V286.25",
    fill: "url(#paint67_linear_2714_20238)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M277.181 277.446V265.961H285.603V271.32H281.009V272.852H278.712V277.354",
    fill: "url(#paint68_linear_2714_20238)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M290.962 272.084H282.157V273.998H290.962V272.084Z",
    fill: "url(#paint69_linear_2714_20238)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M277.181 289.311V300.795H285.603V295.436H281.009V293.904H278.712V289.402",
    fill: "url(#paint70_linear_2714_20238)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M291.345 291.992H280.626V293.906H291.345V291.992Z",
    fill: "url(#paint71_linear_2714_20238)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M272.587 286.635V297.354H277.181",
    fill: "url(#paint72_linear_2714_20238)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M272.587 278.596L272.656 267.532L277.563 267.494",
    fill: "url(#paint73_linear_2714_20238)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M277.257 278.162L272.663 278.246L272.709 280.543L277.211 280.459",
    fill: "url(#paint74_linear_2714_20238)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M829.978 277.49V258.655C829.978 254.23 833.561 250.646 837.987 250.646H913.081C917.507 250.646 921.09 254.23 921.09 258.655V315.374C921.09 319.8 917.507 323.383 913.081 323.383H838.285C833.699 323.383 829.978 319.662 829.978 315.076V277.49Z",
    fill: "url(#paint75_linear_2714_20238)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M913.433 265.194H845.26V261.365C845.26 259.252 846.975 257.537 849.088 257.537H909.605C911.718 257.537 913.433 259.252 913.433 261.365V265.194Z",
    fill: "url(#paint76_linear_2714_20238)",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M845.268 302.709H913.441V306.537C913.441 308.65 911.726 310.365 909.613 310.365H849.096C846.983 310.365 845.268 308.65 845.268 306.537V302.709Z",
    fill: "url(#paint77_linear_2714_20238)",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M976.982 269.787H892.761V298.116H976.982V269.787Z",
    fill: "url(#paint78_linear_2714_20238)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M834.572 275.152H840.299C842.634 275.152 844.525 277.043 844.525 279.379V289.294C844.525 291.629 842.634 293.52 840.299 293.52H834.572V275.145V275.152Z",
    fill: "url(#paint79_linear_2714_20238)",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M834.748 271.811H840.689C842.458 271.811 843.89 270.379 843.89 268.61V262.921L844.908 262.898H838.53C836.325 262.898 834.533 264.69 834.533 266.895V300.645C834.533 302.85 836.325 304.642 838.53 304.642H844.908L843.76 304.473V298.838C843.76 296.901 842.19 295.331 840.253 295.331H834.87",
    fill: "url(#paint80_linear_2714_20238)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M834.748 271.811H840.689C842.458 271.811 843.89 270.379 843.89 268.61V262.921L844.908 262.898H838.53C836.325 262.898 834.533 264.69 834.533 266.895V300.645C834.533 302.85 836.325 304.642 838.53 304.642H844.908L843.76 304.473V298.838C843.76 296.901 842.19 295.331 840.253 295.331H834.87",
    stroke: "#212120",
    strokeWidth: 0.75,
    strokeMiterlimit: 10
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M352.98 251.412V260.363L357.957 265.653H487.734V273.907V293.737H499.984V303.499L506.492 310.421V321.408H656.942V315.711L654.262 312.863L660.77 305.941L599.518 300.245L580.377 282.337V252.224L352.98 251.412Z",
    fill: "url(#paint81_linear_2714_20238)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M1011.97 269.789H976.984V298.118H1011.97V269.789Z",
    fill: "url(#paint82_linear_2714_20238)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.75 259.07H999.953V269.789H1075.75V259.07Z",
    fill: "url(#paint83_linear_2714_20238)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1075.75 298.119H999.953V308.838H1075.75V298.119Z",
    fill: "url(#paint84_linear_2714_20238)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1123.99 275.156H1107.14V292H1123.99V275.156Z",
    fill: "url(#paint85_linear_2714_20238)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.24 275.268H1123.99V291.231H1136.24V275.268Z",
    fill: "url(#paint86_linear_2714_20238)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1120.16 275.157V260.609H1137.3V262.883H1132.41V267.5H1127.82V275.272L1120.16 275.157Z",
    fill: "url(#paint87_linear_2714_20238)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.11 292.222V298.125H1119.39V308.079H1136.24V290.469",
    fill: "url(#paint88_linear_2714_20238)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1115.57 275.154V270.561H1120.24",
    fill: "url(#paint89_linear_2714_20238)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M1136.81 293.148H1133.75V298.891H1136.81V293.148Z",
    fill: "url(#paint90_linear_2714_20238)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1133.75 294.297H1131.84V297.359H1133.75V294.297Z",
    fill: "url(#paint91_linear_2714_20238)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.39 267.885H1134.32V273.627H1137.39V267.885Z",
    fill: "url(#paint92_linear_2714_20238)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M1134.32 269.033H1132.41V272.096H1134.32V269.033Z",
    fill: "url(#paint93_linear_2714_20238)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M1147.72 260.609H1136.24V308.845H1147.72V260.609Z",
    fill: "url(#paint94_linear_2714_20238)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M778.68 68.4279V77.6157H774.852V148.055L745.267 198.351L745.474 200.119H708.578L708.662 199.537L678.38 148.055V77.6157H674.552V68.4279H683.74V65.3653H690.631V62.3027H728.913L727.558 71.4905H676.084V74.5531H776.383V71.4905H726L727 67.7924L726 67.7848L726.5 62.3027H762.602V65.3653H769.492V68.4279H778.68Z",
    fill: "#56A3D2"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M734.97 198.354H717.567V263.671H734.97V198.354Z",
    fill: "#56A3D2"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M693.863 117.348V150.86L719.986 198.675H733.424L763.628 149.88V117.348H693.863Z",
    fill: "url(#paint95_linear_2714_20238)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M698.273 125.307V154.708L721.899 199.693L722.828 275.373H731.008L731.753 199.693L759.524 151.875L759.495 125.307H698.273Z",
    stroke: "#E4E2D7",
    strokeMiterlimit: 10
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 136.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 144.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 152.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 160.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 711.5,
    cy: 163.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.5,
    cy: 149.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.5,
    cy: 159.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 713.5,
    cy: 141.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 709.5,
    cy: 154.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 168.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.5,
    cy: 168.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 717.5,
    cy: 177.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 719.5,
    cy: 185.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 176.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 184.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.5,
    cy: 183.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 736.5,
    cy: 176.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 739.5,
    cy: 169.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.5,
    cy: 163.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 733.5,
    cy: 155.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 735.5,
    cy: 147.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 742.5,
    cy: 153.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 743.5,
    cy: 162.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 732.5,
    cy: 170.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 725.5,
    cy: 192.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 726.5,
    cy: 200.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 208.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 216.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 224.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 232.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 240.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 248.5,
    r: 3.5,
    fill: "#ED2024"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 727.5,
    cy: 259.5,
    r: 3.5,
    fill: "#ED2024"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M728.99 71.4922L728.5 74.5548H676.084V71.4922H728.99Z",
    fill: "#98A8A7"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M776.384 71.4922V74.5548H730.384L730.016 71.4922H776.384Z",
    fill: "#98A8A7"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M776.383 71.4922H676.084V74.5548H776.383V71.4922Z",
    fill: "#3184AD"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2714_20238",
    x1: 714.748,
    y1: 412.779,
    x2: 714.748,
    y2: 641.623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2714_20238",
    x1: 261.707,
    y1: 365.115,
    x2: 1169.9,
    y2: 365.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2714_20238",
    x1: 242.727,
    y1: 375.825,
    x2: 264.548,
    y2: 375.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2714_20238",
    x1: 1085.71,
    y1: 282.426,
    x2: 1094.89,
    y2: 282.426,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2714_20238",
    x1: 1097.95,
    y1: 283.563,
    x2: 1107.14,
    y2: 283.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2714_20238",
    x1: 1136.24,
    y1: 281.266,
    x2: 1147.72,
    y2: 281.266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2714_20238",
    x1: 1094.89,
    y1: 283.18,
    x2: 1097.95,
    y2: 283.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2714_20238",
    x1: 1091.83,
    y1: 321.09,
    x2: 1101.78,
    y2: 321.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2714_20238",
    x1: 1094.89,
    y1: 247.577,
    x2: 1111.74,
    y2: 247.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2714_20238",
    x1: 1101.78,
    y1: 265.951,
    x2: 1104.85,
    y2: 265.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2714_20238",
    x1: 1102.55,
    y1: 272.088,
    x2: 1104.08,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2714_20238",
    x1: 1104.08,
    y1: 272.088,
    x2: 1105.61,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2714_20238",
    x1: 1105.61,
    y1: 272.088,
    x2: 1107.14,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2714_20238",
    x1: 1101.02,
    y1: 272.088,
    x2: 1102.55,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2714_20238",
    x1: 1099.49,
    y1: 272.088,
    x2: 1101.02,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2714_20238",
    x1: 1097.95,
    y1: 272.088,
    x2: 1099.49,
    y2: 272.088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2714_20238",
    x1: 314.774,
    y1: 272.576,
    x2: 358.455,
    y2: 297.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2714_20238",
    x1: 329.628,
    y1: 283.563,
    x2: 338.05,
    y2: 283.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2714_20238",
    x1: 313.343,
    y1: 275.056,
    x2: 357.03,
    y2: 300.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2714_20238",
    x1: 325.8,
    y1: 283.563,
    x2: 330.394,
    y2: 283.563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2714_20238",
    x1: 312.554,
    y1: 276.437,
    x2: 356.242,
    y2: 301.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2714_20238",
    x1: 321.971,
    y1: 283.19,
    x2: 326.565,
    y2: 283.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2714_20238",
    x1: 310.648,
    y1: 279.752,
    x2: 354.328,
    y2: 304.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2714_20238",
    x1: 314.315,
    y1: 283.19,
    x2: 318.909,
    y2: 283.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2714_20238",
    x1: 311.597,
    y1: 278.1,
    x2: 355.285,
    y2: 303.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2714_20238",
    x1: 318.143,
    y1: 283.192,
    x2: 322.737,
    y2: 283.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2714_20238",
    x1: 751.308,
    y1: 199.719,
    x2: 751.308,
    y2: 219.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2714_20238",
    x1: 588.034,
    y1: 361.658,
    x2: 611.769,
    y2: 361.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE3E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFDE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#F0EBD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D6CDC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#EDEDEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D5BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2714_20238",
    x1: 1077.43,
    y1: 305.881,
    x2: 1108.67,
    y2: 305.881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2714_20238",
    x1: 1075.79,
    y1: 262.488,
    x2: -50.5344,
    y2: 262.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2714_20238",
    x1: 1086.85,
    y1: -53.8656,
    x2: 1093.74,
    y2: -53.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2714_20238",
    x1: 579.826,
    y1: 262.052,
    x2: 580.89,
    y2: 303.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2714_20238",
    x1: 580.002,
    y1: 268.928,
    x2: 580.752,
    y2: 298.221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2714_20238",
    x1: 348.608,
    y1: 275.365,
    x2: 349.045,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2714_20238",
    x1: 360.483,
    y1: 275.365,
    x2: 360.92,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2714_20238",
    x1: 372.366,
    y1: 275.365,
    x2: 372.795,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2714_20238",
    x1: 384.241,
    y1: 275.365,
    x2: 384.678,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2714_20238",
    x1: 396.117,
    y1: 275.365,
    x2: 396.553,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2714_20238",
    x1: 408,
    y1: 275.365,
    x2: 408.436,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2714_20238",
    x1: 419.874,
    y1: 275.365,
    x2: 420.311,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2714_20238",
    x1: 431.758,
    y1: 275.365,
    x2: 432.194,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2714_20238",
    x1: 443.632,
    y1: 275.365,
    x2: 444.069,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2714_20238",
    x1: 455.515,
    y1: 275.365,
    x2: 455.944,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2714_20238",
    x1: 467.39,
    y1: 275.365,
    x2: 467.826,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2714_20238",
    x1: 479.266,
    y1: 275.365,
    x2: 479.702,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2714_20238",
    x1: 491.149,
    y1: 275.365,
    x2: 491.585,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2714_20238",
    x1: 503.023,
    y1: 275.365,
    x2: 503.46,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2714_20238",
    x1: 514.907,
    y1: 275.365,
    x2: 515.343,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2714_20238",
    x1: 526.782,
    y1: 275.365,
    x2: 527.218,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2714_20238",
    x1: 538.665,
    y1: 275.365,
    x2: 539.093,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2714_20238",
    x1: 550.54,
    y1: 275.365,
    x2: 550.977,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2714_20238",
    x1: 562.415,
    y1: 275.365,
    x2: 562.852,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2714_20238",
    x1: 574.298,
    y1: 275.365,
    x2: 574.735,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2714_20238",
    x1: 586.173,
    y1: 275.365,
    x2: 586.609,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2714_20238",
    x1: 598.056,
    y1: 275.365,
    x2: 598.493,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2714_20238",
    x1: 609.931,
    y1: 275.365,
    x2: 610.367,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2714_20238",
    x1: 621.814,
    y1: 275.365,
    x2: 622.242,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2714_20238",
    x1: 633.689,
    y1: 275.365,
    x2: 634.126,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2714_20238",
    x1: 645.564,
    y1: 275.365,
    x2: 646.001,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2714_20238",
    x1: 657.447,
    y1: 275.365,
    x2: 657.883,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2714_20238",
    x1: 669.323,
    y1: 275.365,
    x2: 669.759,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2714_20238",
    x1: 681.205,
    y1: 275.365,
    x2: 681.642,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2714_20238",
    x1: 693.08,
    y1: 275.365,
    x2: 693.517,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2714_20238",
    x1: 704.963,
    y1: 275.365,
    x2: 705.392,
    y2: 292.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2714_20238",
    x1: 256.125,
    y1: 275.353,
    x2: 270.673,
    y2: 275.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2714_20238",
    x1: 256.125,
    y1: 291.566,
    x2: 270.673,
    y2: 291.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2714_20238",
    x1: 277.181,
    y1: 277.83,
    x2: 289.431,
    y2: 277.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2714_20238",
    x1: 277.181,
    y1: 288.93,
    x2: 289.431,
    y2: 288.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2714_20238",
    x1: 277.181,
    y1: 271.703,
    x2: 285.603,
    y2: 271.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2714_20238",
    x1: 282.157,
    y1: 273.041,
    x2: 290.962,
    y2: 273.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2714_20238",
    x1: 277.181,
    y1: 295.053,
    x2: 285.603,
    y2: 295.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2714_20238",
    x1: 280.626,
    y1: 292.949,
    x2: 291.345,
    y2: 292.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2714_20238",
    x1: 272.587,
    y1: 291.994,
    x2: 277.181,
    y2: 291.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2714_20238",
    x1: 272.587,
    y1: 273.045,
    x2: 277.563,
    y2: 273.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2714_20238",
    x1: 272.663,
    y1: 279.349,
    x2: 277.257,
    y2: 279.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2714_20238",
    x1: 829.978,
    y1: 287.015,
    x2: 921.09,
    y2: 287.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8EFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E7D18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2714_20238",
    x1: 845.26,
    y1: 261.365,
    x2: 913.433,
    y2: 261.365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2714_20238",
    x1: 845.268,
    y1: 306.537,
    x2: 913.441,
    y2: 306.537,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DED9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CFCAC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#A8A4A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#8B878D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#F3F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E4E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BFBEC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#847F84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#807B80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7A9AC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2714_20238",
    x1: 934.244,
    y1: 244.567,
    x2: 935.569,
    y2: 327.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EABE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2714_20238",
    x1: 834.572,
    y1: 284.332,
    x2: 844.525,
    y2: 284.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8EFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E7D18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2714_20238",
    x1: 834.533,
    y1: 283.77,
    x2: 844.908,
    y2: 283.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBC926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFFBCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F8EFBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#E7D18D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#CCA246"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C3922E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#EED688"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2714_20238",
    x1: 352.98,
    y1: 286.41,
    x2: 660.77,
    y2: 286.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7DA7D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#35517D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#7AA5D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#174D6B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2714_20238",
    x1: 993.851,
    y1: 244.63,
    x2: 995.114,
    y2: 324.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBC17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#EDD089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F4E8D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C08329"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#EABE81"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2714_20238",
    x1: 999.953,
    y1: 264.43,
    x2: 1075.75,
    y2: 264.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2714_20238",
    x1: 999.953,
    y1: 303.479,
    x2: 1075.75,
    y2: 303.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#401617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#6B4C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#A58A55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#E5D4B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#967857"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#814F2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2714_20238",
    x1: 1107.14,
    y1: 283.578,
    x2: 1123.99,
    y2: 283.578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2714_20238",
    x1: 1123.99,
    y1: 283.246,
    x2: 1136.24,
    y2: 283.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2714_20238",
    x1: 1120.16,
    y1: 267.937,
    x2: 1137.3,
    y2: 267.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2714_20238",
    x1: 1115.11,
    y1: 299.274,
    x2: 1136.24,
    y2: 299.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2714_20238",
    x1: 1115.57,
    y1: 272.857,
    x2: 1120.24,
    y2: 272.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2714_20238",
    x1: 1133.75,
    y1: 296.02,
    x2: 1136.81,
    y2: 296.02,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2714_20238",
    x1: 1131.84,
    y1: 295.828,
    x2: 1133.75,
    y2: 295.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2714_20238",
    x1: 1134.32,
    y1: 270.756,
    x2: 1137.39,
    y2: 270.756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2714_20238",
    x1: 1132.41,
    y1: 270.564,
    x2: 1134.32,
    y2: 270.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2714_20238",
    x1: 1136.24,
    y1: 284.727,
    x2: 1147.72,
    y2: 284.727,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2714_20238",
    x1: 693.863,
    y1: 158.011,
    x2: 763.628,
    y2: 158.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#969595"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#F3F3F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#A4A3A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#515050"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDECED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyCapInjectionUnit);
export default __webpack_public_path__ + "static/media/HyCAPInjectionUnit.75ace52885298fc5facd524359e0b605.svg";
export { ForwardRef as ReactComponent };